import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {
  hasHybridDeliveryFeature,
  isSelfDeliveryOrder
} from 'helpers/functionUtils/hybridDelivery';
import {
  DriverOptOutTitle,
  SelfDeliveryNoteWrap
} from 'routes/App/ordersV2/OrderDetails/DriverOptOut/styles';

const SelfDeliveryNote = ({order}) => {
  const serviceFeatures = useSelector(
    (state) => state.user?.activeLocation?.AllowedServiceFeatures
  );

  if (!hasHybridDeliveryFeature(serviceFeatures) || !isSelfDeliveryOrder(order))
    return null;

  return (
    <SelfDeliveryNoteWrap>
      <DriverOptOutTitle>
        The order will be delivered by restaurant driver. Use Book a Driver to
        get it delivered by Sauce.
      </DriverOptOutTitle>
    </SelfDeliveryNoteWrap>
  );
};

SelfDeliveryNote.propTypes = {
  order: PropTypes.shape({}).isRequired
};

export default SelfDeliveryNote;
